import React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import Typography from "@mui/material/Typography";
import Tooltip from '@mui/material/Tooltip';
import ArrowCircleUpOutlinedIcon from '@mui/icons-material/ArrowCircleUpOutlined';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

export default function ImageGallery({images, updateImage, removeImage, deletedImageList=null}) {

  console.log(images);

  if(images.length === 0){
    return <Typography variant="inherit" noWrap>
    No Image associated with this Product yet!
  </Typography>
  }

  return (
    <ImageList sx={{ width: 520, height: 500 }} columns={2} spacing={2}>
      <ImageListItem key="Subheader" cols={2}>
        <ListSubheader component="div">Product Picture(s) (Max - 5)</ListSubheader>
      </ImageListItem>
      {images?.map((item, index) => (
        <ImageListItem key={index}>
          <img
            srcSet={item["data_url"] || item}
            src={item["data_url"] || item}
            alt={item["data_url"] || item}
            loading="lazy"
          />
          <ImageListItemBar
            actionIcon={
                <>
              <IconButton
                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                aria-label={`edit image ${item["data_url"]}`}
                onClick={() => {
                  updateImage(index)
                  deletedImageList((prev) => [...prev, item])
                }}
              >
                <Tooltip title="Edit Image">
                <ArrowCircleUpOutlinedIcon />
                </Tooltip>
              </IconButton>
              <IconButton
              sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
              aria-label={`remove image ${item["data_url"]}`}
              onClick={() => {
                deletedImageList((prev) => [...prev, item])
                removeImage(index)
              }}
            >
                <Tooltip title="Remove Image">
              <DeleteSweepIcon />
              </Tooltip>
            </IconButton>
            </>
            }
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}